var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pictures"},[_vm._v(" 页面11 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }